import request from '@/util/request'
import Event from '@/util/proto/event'
import { wgs2gcjBatch , wgs2gcj } from '@/util/map'
import { getStaticPath } from '@/util/request'
import config from '../../../../../config'

const latlng = (obj) => new AMap.LngLat(obj.lng , obj.lat)

const latlngsFrom = (arr) => arr.map( i => latlng(i) )

const boundsFrom = arr => new AMap.Bounds(...latlngsFrom(arr)) 

const toGeom = (data) => {
  let geometry = {
    type: data.category,
    coordinates:wgs2gcjBatch(data.points || [])
  }

  if( data.category == 1){
    geometry.radius = data.radius
  }
  else if( data.category == 2 && geometry.coordinates.length == 2){
    geometry.type = 3
  }

  return geometry
}

const groupStatus = (d) => {
  if (d.bindState == 0) {
    return 2
  } else {
    return 1
  }
}

class CarLayer extends Event{
  constructor(){
    super()

    this.map = null
    this.data = []
    this.overlays = {}
    this.ready = false
    this.autoUpdate = false
    this.tickTime = 10
    this.visibleEmptyCluster = false
    this.displayType = {
      visible:{
        '1':true,
        '2':true,
      },
      count:{
        '1':0,
        '2':0,
      },
    }

    this.params = {}
  }

  setOptions(params){
    this.params = params
    if( this.ready ) this.query()
  }

  init(){
    AMapUI.load(['ui/geo/DistrictCluster', 'ui/misc/PointSimplifier'], (DistrictCluster, PointSimplifier) => {
      
      let groupStyleMap = {
        '1': {
          pointStyle: {
            //绘制点占据的矩形区域
            content: PointSimplifier.Render.Canvas.getImageContent(
              getStaticPath('poi/1.png')),
            width: 16,
            height: 20,
          }
        },
        '2': {
          pointStyle: {
            //绘制点占据的矩形区域
            content: PointSimplifier.Render.Canvas.getImageContent(
              getStaticPath('poi/2.png')),
            width: 16,
            height: 20,
          }
        },
      }

      let { visibleEmptyCluster } = this
      this.poiManager = new PointSimplifier({
        zIndex: 2000,
        autoSetFitView: false,
        map: this.map, //所属的地图实例
        getPosition: (item) => {
          return [item.longitude, item.latitude]
        },
        getHoverTitle: (dataItem, idx) => {
          return '车辆编号: ' + dataItem.carNo;
        },
        //使用GroupStyleRender
        renderConstructor: PointSimplifier.Render.Canvas.GroupStyleRender,
        renderOptions: {
          //点的样式
          pointStyle: {
            width: 16,
            height: 16,
            fillStyle: '#A2D0FA'
          },
          getGroupId: function(item, idx) {
            return groupStatus(item)
          },
          groupStyleOptions: function(gid) {
            return groupStyleMap[gid]
          }
        }
      });

      this.poiCluster = new DistrictCluster({
        // zIndex: 100,
        map: this.map,
        autoSetFitView: false,
        renderOptions: {
          animEnable: false,
          featureStyleByLevel: {
            country: { fillStyle: 'rgba(0,0,0,0)' },
            province: { fillStyle: 'rgba(0,0,0,0)' },
            city: { fillStyle: 'rgba(0,0,0,0)' },
            district: { fillStyle: 'rgba(0,0,0,0)' }
          },
          featureStyle: {
            lineWidth: 0
          },
          featureEventSupport: false, //区划面是否开启事件支持
          featureClickToShowSub: false, //点击区划面是否触发进入子级区划
          hoverOptions: null,
          getClusterMarker: function(feature, dataItems, recycledMarker) {
            if (visibleEmptyCluster || dataItems.length > 0) {
              return DistrictCluster.ClusterMarkerStrategy.DEFAULT.call(this, feature, dataItems, recycledMarker)
            }
          }

        },
        getPosition: (item) => {
          return [item.longitude, item.latitude]
        },
      });

      this.poiManager.on('pointClick', this.handlePointClick.bind(this))
      this.poiManager.on('pointMouseover', this.handlePointOver.bind(this))
      this.poiManager.on('pointMouseout', this.handlePointOut.bind(this))

      this.ready = true
      this.query()
    });
  }

  setMap(map){
    if( map === null ){
      this.clear()
    }else{
      this.map = map
      if( this.ready ){
        this.query()
      }else{
        this.init()
      }
    }
  }

  query(){
    request.carsMap({...this.getBounds() , ...this.params}).then(resp => {
      if (resp.code == 0) {
        this.render(resp)
      }

      this.pollHandler = null
      if( this.autoUpdate ){
        this.pollHandler = setTimeout(this.query.bind(this), this.tickTime * 1000)
      }
    })
  }

  updateViewLayer(){

  }

  getBounds() {
    let rate = 1.5
    let def = this.map.getBounds()
    let ne = def.getNorthEast()
    let c = def.getCenter()

    let r = c.distance(ne)
    return {
      centerLat: c.getLat(),
      centerLng: c.getLng(),
      radius: 1e8
    }
  }

  render(resp){
    let data = []
    this.displayType.count = {
      '1':0,
      '2':0,
    }

    for(let i of (resp.data || [])){
      if(i.bindState == 1) i.poiType = 2
      if(i.bindState == 0) i.poiType = 1

      if (i.latitude && i.longitude) {
        this.displayType.count[i.poiType]++;

        if (
          this.displayType.visible[i.poiType]
        ) {
          let c = wgs2gcj(i.longitude, i.latitude)

          data.push({
            id: i.id,
            carNo: i.carNo,
            longitude: c[0],
            latitude: c[1],
            bindState: i.bindState,
            displayLabel: i.license || i.carNo,
            statusIcon: i.bindState ? 'success' : 'primary',
            licenseLite: (i.license || '').replace(/[^a-z0-9]/ig, '').toUpperCase(),
            searchList:[i.carNo , (i.license || '').replace(/[^a-z0-9]/ig, '').toUpperCase() , (i.license || '').replace(/[^0-9]/ig, '').toUpperCase()]
          })

        }
      }
    }

    this.data = data

    /*if (this.visibleCluster) {
      this.poiCluster.setData(this.data);
    }
*/
    //if (this.visiblePoint) {
      this.poiManager.setData(this.data)
      //this.poiCluster.setData(this.data)
    //}
    this.trigger('update' , this.getStatsData())
    //this.updateFocus()

    if (!this.ready) {
      //this.updateViewLayer()
    }
  }

  getStatsData(){
    return [
      {icon:getStaticPath('poi/1.png'), title:'已绑定 '+this.displayType.count['1']+' 辆' , },
      {icon:getStaticPath('poi/2.png'), title:'未绑定 '+this.displayType.count['2']+' 辆' , },
    ]
  }

  handlePointClick(e,record){
    console.log('click',e)
    this.trigger('click' , record.data)
  }

  handlePointOver(e , record){
    console.log('focus' , record)
    this.trigger('focus' , record.data)
  }
  handlePointOut(e , record){
    this.trigger('focus' , null)
  }
  destroy() {

  }
}

export default CarLayer